import React from 'react';
import './style.scoped.scss';
import { Button } from 'react-bootstrap';
import { ROUTES } from '../../assets/constants/strings';
import { IoMdOpen } from 'react-icons/io';

const UserUpdates = ({ className, title, array }) => {
  return (
    <div className={`userUpdates ${className ? className : ''}`}>
      <h3>{title}</h3>
      {array &&
        array.length > 0 &&
        array
          .sort((v1, v2) => (v1.createdDate < v2.createdDate ? 1 : -1))
          .slice(0, 5)
          .map((item) => {
            return (
              <a
                href={ROUTES.DOCUMENT(item.id)}
                target='_blank'
                rel='noreferrer'
                key={item.id}
                className='userUpdates__updates'
              >
                <b className='userUpdates__title'>
                  {item.title}
                  <span className='ml-2'>
                    <IoMdOpen />
                  </span>
                </b>
                <div className='userUpdates__info'>
                  <span className='userUpdates__levelOne'>
                    {item.levelOne.Title}
                  </span>
                  <span className='userUpdates__versionDate'>
                    Updated Date:{' '}
                    {new Date(item.createdDate).toLocaleDateString()}
                  </span>
                </div>
              </a>
            );
          })}
      {/* <Button className='userUpdates__button'>View All</Button> */}
    </div>
  );
};

export default UserUpdates;
